import React from "react";
import { Badge, Card, Modal } from "react-bootstrap";
import { IPrograma } from "../ProgramaListagem";
import Table from "components/TableComp";
import PersonalizacaoDetalhe from "./PersonalizacaoDetalhe";
import BadgeANTD from "antd/lib/badge";

interface IProgramaDetalheModal {
  show: boolean;
  onHide: Function;
  programa: IPrograma;
}

export default function ProgramaDetalheModal({
  show,
  onHide,
  programa,
}: IProgramaDetalheModal) {
  const getTipoCampo = (tipoCampoId: number) => {
    switch (tipoCampoId) {
      case 1:
        return "Texto";
      case 2: 
        return "Texto multilinha";
      case 3:
        return "Seleção Única";
      case 4:
        return "Data";
      case 5:
        return "Sim / Não";
      case 6:
        return "Período";
      case 7:
        return "Seleção Múltipla";
      default:
        return `Tipo ${tipoCampoId}`;
    }
  };
const formatarData = (data?: string) => {
  if (!data) return "-";

  return new Date(data).toLocaleDateString("pt-BR");
};

  const formatarResposta = (escolha: any) => {
    let valor: any = escolha.resposta;

    try {
      valor = JSON.parse(escolha.resposta);
    } catch {
      valor = escolha.resposta;
    }

    switch (escolha.campo.tipocampo_id) {
      case 1:
        return valor;

      case 3: {
        const opcao = escolha.campo.opcoes?.find(
          (o: any) => o.id === Number(valor),
        );

        return <Badge>{opcao?.nome || valor}</Badge>
      }

      case 4:
        return formatarData(valor);

      case 5:
        return valor ? (
          <Badge bg="success">Sim</Badge>
        ) : (
          <Badge bg="danger">Não</Badge>
        );

      case 6:
        return (
          <div>
            <div>
              <strong>Início:</strong> {formatarData(valor?.inicio)}
            </div>
            <div>
              <strong>Fim:</strong> {formatarData(valor?.fim)}
            </div>
          </div>
        );

      case 7:
        if (!Array.isArray(valor)) {
          return "-";
        }

        return (
          <div
            style={{
              display: "flex",
              gap: 4,
              flexWrap: "wrap",
            }}
          >
            {valor.map((id: number) => {
              const opcao = escolha.campo.opcoes?.find(
                (o: any) => o.id === id,
              );

              return (
                <Badge
                  key={id}
                  bg="primary"
                >
                  {opcao?.nome || id}
                </Badge>
              );
            })}
          </div>
        );

      default:
        return typeof valor === "object"
          ? JSON.stringify(valor)
          : String(valor);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => onHide()}
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div>{programa.titulo}</div>
          <div className="mt-1">
            <BadgeANTD 
              color={`${programa.categoria?.cor}`}
              text={ programa.categoria?.nome}
            />
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Card className="mb-3">
          <Card.Header>
            <Card.Title>Alvos</Card.Title>
          </Card.Header>

          <Card.Body>
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              {programa.alvos?.map((alvo) => (
                <Badge
                  key={alvo.id}
                  bg="info"
                >
                  {alvo.nome}
                </Badge>
              ))}
            </div>
          </Card.Body>
        </Card>

        <Card>
          <Card.Header>
            <Card.Title>Detalhamento</Card.Title>
          </Card.Header>

          <Card.Body>
            <Table
              columns={[
                {
                  Header: "#",
                  accessor: "campo.ordem",
                  sort: true,
                  Cell: (row: any) => (
                    <span>
                      {row.row.original.campo.ordem + 1}
                    </span>
                  ),
                },
                {
                  Header: "Campo",
                  accessor: "campo.nome",
                  sort: true,
                  Cell: (row: any) => (
                    <strong>
                      {row.row.original.campo.nome}
                    </strong>
                  ),
                },
                {
                  Header: "Tipo",
                  accessor: "campo.tipocampo_id",
                  sort: true,
                  Cell: (row: any) => (
                    <Badge bg="light" text="dark">
                      {getTipoCampo(
                        row.row.original.campo.tipocampo_id,
                      )}
                    </Badge>
                  ),
                },
                {
                  Header: "Resposta",
                  accessor: "resposta",
                  sort: false,
                  Cell: (row: any) =>
                    formatarResposta(row.row.original),
                },
              ]}
              data={
                programa.escolhas
                  ?.slice()
                  .sort(
                    (a, b) =>
                      a.campo.ordem - b.campo.ordem,
                  ) || []
              }
            />
          </Card.Body>
        </Card>
        <Card>
            <Card.Header>
                <Card.Title>
                    Personalização - pré-visualização
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <Card>
                    <Card.Body>
                        <i className="mdi mdi-lock-outline me-1" />
                        Dicas - Seleção Múltipla
                    </Card.Body>                     
                </Card>
                <PersonalizacaoDetalhe 
                  personalizacoes={programa.campos_personalizados}
                />
            </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
}